import { FC } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

interface LoadingOverlayProps {
  message?: string
}

const LoadingOverlay: FC<LoadingOverlayProps> = ({ message = 'Procesando, por favor espere...' }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.35)',
      }}
    >
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: 'rgba(255,255,255,0.95)',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          boxShadow: 3,
        }}
      >
        <CircularProgress size={28} />
        <Typography variant="body1">{message}</Typography>
      </Box>
    </Box>
  )
}

export default LoadingOverlay
